export class RemittanceSplit {
    constructor(
    public PaymentDetail_Remittance_RemittanceId: number,
    public PaymentDetail_Remittance_RemittanceAmounts: number[]) {}
}



// WEBPACK FOOTER //
// ./src/app/models/remittanceSplit.model.ts